import {useNavigate} from "react-router-dom";
import {TruncatedHtmlTextContent} from "../../../components/TruncatedHtmlTextContent/TruncatedHtmlTextContent";
import React from "react";
import CatapultLogo from "../../../assets/Logo/catapult_logo2.png";

const PlaylistCard = ({ playlist }) => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        const url = `/playlists/${playlist.id}`;

        navigate(url);

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const playlistCover = () => {
        if (playlist.cover_images.length === 1) {
            return  <img src={playlist?.cover_images[0]} className="card-img-top program-masterclass-card-thumbnail img-fluid rounded-3 mb-3"
                         alt={playlist?.name}/>;
        } else if (playlist.cover_images.length === 4) {
            return <>
                <div className="playlist-thumbnails-grid mb-3 rounded-3 overflow-hidden">
                    {playlist.cover_images?.map((cover, index) => {
                        return (
                            <React.Fragment key={playlist.id}>
                                <img
                                    src={cover}
                                    alt={`cover ${index}`}
                                    className="playlist-thumb"
                                />
                            </React.Fragment>
                        );
                    })}
                </div>
            </>;
        } else if (playlist.cover_images.length === 2 || playlist.cover_images.length === 3) {
            return <>
                <div className="playlist-thumbnails-grid mb-3 rounded-3 overflow-hidden">
                    <img
                        src={playlist.cover_images[0]}
                        alt="cover 1"
                        className="playlist-thumb"
                    />
                    <img
                        src={playlist.cover_images[1]}
                        alt="cover 2"
                        className="playlist-thumb"
                    />
                    <img
                        src={playlist.cover_images[1]}
                        alt="cover 3"
                        className="playlist-thumb"
                    />
                    <img
                        src={playlist.cover_images[0]}
                        alt="cover 4"
                        className="playlist-thumb"
                    />
                </div>
            </>;
        } else if (playlist.cover_images.length === 0) {
            return <img src={CatapultLogo} className="card-img-top program-masterclass-card-thumbnail img-fluid rounded-3 mb-3"
                        alt={playlist?.name}/>;
        }
    }

    return (
        <>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6 col-12">
                <div
                    className="card text-white m-3 p-4 program-masterclass-card rounded-3"
                    onClick={handleNavigate}
                >
                    {playlistCover()}

                    <h5 className="card-title mb-3">{playlist?.name}</h5>
                </div>
            </div>
        </>
    );
};

export default PlaylistCard;